import * as types from "./actionTypes";

const initialState = {
  result: [],
  query: "",
  currentPage: 1,
  totalPages: null,
  isSearchFinished: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.QUERY_UPDATE:
      return {
        ...state,
        isSearchFinished: false,
        query: action.query
      };

    case types.FETCH_SEARCH_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        currentPage: action.result.current_page,
        totalPages: action.result.total_pages
      };

    case types.FETCH_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        result: [...state.result, ...action.result.data],
        currentPage: action.result.current_page
      };

    case types.FETCH_SEARCH_FINISH:
      return {
        ...state,
        isSearchFinished: true
      };

    case types.CLEAR_SEARCH:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/search/reducer.js